// extracted by mini-css-extract-plugin
export default {"AddRFZOArticles":"AddRFZOArticles_AddRFZOArticles__39lle","header":"AddRFZOArticles_header__5dyHq"};